import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_READ_ONLY } = ROLES;

const ALLOWED_ROLES_VIEW_MARKETING = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_READ_ONLY];

const ALLOWED_ROLES_EDIT_MARKETING = [ROLE_OWNER, ROLE_ADMINISTRATOR];

export function canViewMarketing(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_VIEW_MARKETING);
}

export function canEditMarketing(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_EDIT_MARKETING);
}
